<template>
  <Card 
    :title="$t('SessionViewer.Device Statistics')"
    id="SessionViewerDeviceStats"
  >
    <CardSection v-if="deviceStats">
      <Layout>
        <LayoutSection v-for="(table, index) in tables" :key="index">
          <div :class="{ 'highlighted': currDevice && currDevice === table.value}">
            <table class="table table-bordered table-condensed">
              <thead>
                <tr>
                  <th colspan="3">
                    {{table.label}} {{currDevice && currDevice === table.value ? `(${$t('SessionViewer.currentSessionDevice')})` : ''}}
                  </th>
                </tr>
                <tr>
                  <th></th>
                  <th>{{$t('SessionViewer.Average Order Value')}}</th>
                  <th>{{$t('SessionViewer.Conversion Rate')}}</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(item, index) in days"
                  :key="index"
                >
                  <td>{{item.label}}</td>
                  <td><Formatter type="currency" :currency="currency" :value="getAOV(table.value, item.value)"/></td>
                  <td>
                    <Formatter type="percent" :value="getCR(table.value, item.value)"/>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </LayoutSection>
      </Layout>
    </CardSection>
    <CardSection v-else>
      <List tight :emptyText="$t('SessionViewer.No Device Statistics')"/>
    </CardSection>
  </Card>
</template>

<script>

export default {
  name: 'SessionViewerDeviceStats',
  props: {
    deviceStats: {
      type: Object,
      required: true
    },
    userAgent: {
      type: String,
      required: true
    },
    currency: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      currDevice: null,
      days: [
        { value: 'days1', label: this.$t('SessionViewer.1Day') },
        { value: 'days7', label: this.$t('SessionViewer.7Days') },
        { value: 'days30', label: this.$t('SessionViewer.30Days') },
        { value: 'days90', label: this.$t('SessionViewer.90Days') }
      ],
      tables: [
        { value: 'computer', label: this.$t('SessionViewer.Computer') },
        { value: 'tablet', label: this.$t('SessionViewer.Tablet') },
        { value: 'mobile', label: this.$t('SessionViewer.Mobile') }
      ]
    }
  },
  mounted() {
    this.currDevice = this.getCurrDevice()
  },
  methods: {
    getCurrDevice() {
      if (!this.userAgent) return ''
      if (this.userAgent.match(/(Tablet|iPad)/i)) {
        return 'tablet'
      } else if (this.userAgent.match(/(iPhone|iPod|BlackBerry|Mobile|IEMobile|Opera Mobi|Opera Mini|phone)/i)) {
        return 'mobile'
      } else {
        return 'computer'
      }
    },
    getAOV(type, day) {
      if (this.deviceStats && this.deviceStats[type] && this.deviceStats[type][day]) {
        return this.deviceStats[type][day].aov
      }
      return null
    },
    getCR(type, day) {
      if (this.deviceStats && this.deviceStats[type] && this.deviceStats[type][day]) {
        if (this.deviceStats[type][day].cr) {
          return this.deviceStats[type][day].cr / 100
        }
        return 0
      }
      return null
    }
  },
  computed: {
  }
}
</script>

<style lang="scss">
#SessionViewerDeviceStats {
  .highlighted {
    border: 2px solid red;
  }
}
</style>
